import { request } from "@/utils/remoteRequest";

export function login(data) {
  return request({
    url: "/framework/login/loginUserNameAndPwd",
    method: "get",
    params: data,
  });
}

export function studentLogin(data) {
  return request({
    url: "/framework/resumeInfo/login",
    method: "get",
    params: data,
  });
}

export function logout(data) {
  return request({
    url: "/framework/resumeInfo/loginOut",
    method: "post",
    data,
  });
}

export function register(data) {
  return request({
    // url: "/user/register",
    url: "/resumeInfo/register",
    method: "post",
    data,
  });
}

export function resetPassword(data) {
  return request({
    // url: "/user/register",
    url: "resumeInfo/modifyPassword",
    method: "post",
    data,
  });
}

export function modifyPassword(data) {
  return request({
    // url: "/user/register",
    url: "users/modifyPassword",
    method: "post",
    data,
  });
}

export function sendVerificationCode(data) {
  return request({
    // url: "/user/register",
    url: "resumeInfo/sendVerificationCode",
    method: "post",
    data,
  });
}

export function validVerificationCode(data) {
  return request({
    // url: "/user/register",
    url: "resumeInfo/validVerificationCode",
    method: "post",
    data,
  });
}
export function modifyPasswordByPhoneAndCode(data) {
  return request({
    // url: "/user/register",
    url: "resumeInfo/modifyPasswordByPhoneAndCode",
    method: "post",
    data,
  });
}
